import styled from 'styled-components';

const SectionWrapper = styled.section`
  padding: 96px 0;
  background: #f7f9fc;

  @media (max-width: 990px) {
    padding: 72px 0;
  }
  @media (max-width: 767px) {
    padding: 56px 0;
  }
`;

export const Header = styled.header`
  max-width: 720px;
  margin: 0 auto 44px;
  text-align: center;

  .eyebrow {
    display: block;
    margin-bottom: 8px;
    color: #46679f;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.15em;
  }

  h2 {
    margin: 0 0 14px;
    color: #0f2137;
    font-size: 30px;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -0.03em;
  }

  p {
    margin: 0;
    color: #5d646d;
    font-size: 17px;
    line-height: 1.7;
  }

  @media (max-width: 767px) {
    margin-bottom: 32px;
    h2 {
      font-size: 24px;
    }
    p {
      font-size: 16px;
    }
  }
`;

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
  align-items: stretch;

  @media (max-width: 1199px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 767px) {
    grid-template-columns: minmax(0, 1fr);
    max-width: 480px;
    margin: 0 auto;
  }
`;

export const Card = styled.article`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 28px 24px 24px;
  border: 1px solid #d9e2f0;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 8px 30px rgba(15, 33, 55, 0.06);

  &.suggested {
    border: 2px solid #fdb32a;
    padding: 27px 23px 23px;
    box-shadow: 0 14px 40px rgba(15, 33, 55, 0.14);
  }

  .tag {
    position: absolute;
    top: -13px;
    left: 24px;
    padding: 4px 12px;
    border-radius: 999px;
    background: #fdb32a;
    color: #0f2137;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  h3 {
    margin: 0 0 4px;
    color: #0f2137;
    font-size: 21px;
    font-weight: 700;
    letter-spacing: -0.01em;
  }

  .tagline {
    margin: 0 0 18px;
    min-height: 44px;
    color: #5d646d;
    font-size: 14px;
    line-height: 1.55;
  }

  .price {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin-bottom: 20px;
    color: #0f2137;

    strong {
      font-size: 40px;
      font-weight: 700;
      line-height: 1;
      letter-spacing: -0.03em;
    }

    span {
      color: #5d646d;
      font-size: 14px;
    }
  }

  .price .from {
    font-size: 16px;
    font-weight: 600;
  }

  .volume {
    margin: -8px 0 18px;
    color: #46679f;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.5;
  }

  ul {
    flex: 1;
    margin: 0 0 24px;
    padding: 0;
    list-style: none;
  }

  li {
    position: relative;
    margin-bottom: 10px;
    padding-left: 26px;
    color: #343d48;
    font-size: 15px;
    line-height: 1.5;
  }

  li::before {
    content: '';
    position: absolute;
    left: 2px;
    top: 4px;
    width: 12px;
    height: 7px;
    border-left: 2px solid #46679f;
    border-bottom: 2px solid #46679f;
    transform: rotate(-45deg);
  }

  /* Same footer height on every card (button 46px + note gap 10px + two note
     lines), so the buttons sit on one line whether or not a note follows. */
  .footer {
    min-height: 96px;

    @media (max-width: 767px) {
      min-height: 0;
    }
  }

  .action {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    min-height: 46px;
    padding: 0 16px;
    border: 2px solid #0f2137;
    border-radius: 6px;
    background: transparent;
    color: #0f2137;
    font-family: inherit;
    font-size: 15px;
    font-weight: 700;
    text-decoration: none;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;

    &:hover,
    &:focus-visible {
      background: #0f2137;
      color: #fff;
    }
  }

  &.suggested .action {
    border-color: #fdb32a;
    background: #fdb32a;
    color: #0f2137;

    &:hover,
    &:focus-visible {
      background: #f29e02;
      border-color: #f29e02;
    }
  }

  .note {
    margin: 10px 0 0;
    color: #5d646d;
    font-size: 13px;
    line-height: 1.5;
    text-align: center;
  }
`;

export const Fineprint = styled.p`
  max-width: 760px;
  margin: 28px auto 0;
  color: #5d646d;
  font-size: 14px;
  line-height: 1.7;
  text-align: center;
`;

export default SectionWrapper;
